@if (to.bulkSelectOptions.enabled) {
	<div class="o-flex o-flex--vcenter o-flex--space-between form-check custom-checkbox">
		<angie-luds-checkbox
			[checked]="bulkChecked"
			[disabled]="formControl.disabled || to.bulkSelectOptions.disabled"
			[indeterminate]="bulkIndeterminate"
			[label]="this.bulkLabel"
			[checkboxAriaLabel]="to.bulkSelectOptions.checkboxAriaLabel || to.bulkSelectOptions.label"
			[name]="to.bulkSelectOptions.name"
			[id]="to.bulkSelectOptions.id || id + '_' + 'bulk'"
			[useHtmlLabel]="true"
			[value]="to.bulkSelectOptions.value"
			(checkedEvent)="onBulkChecked($event)"></angie-luds-checkbox>
		<div>
			@if (to.bulkSelectOptions.counter) {
				<span class="p-default mr-16">{{ '(' + checkedCount + '/' + totalCount + ')' }}</span>
			}
			@if (to.bulkSelectOptions.collapse) {
				<lu-icon
					[icon]="iconSignal()"
					tabindex="0"
					role="button"
					(click)="toggle()"
					(keydown.enter)="toggle()"
					(keydown.space)="toggle()"
					[attr.aria-label]="collapsedSignal() ? ('lup.a11y.expand' | translate) : ('lup.a11y.collapse' | translate)" />
			}
		</div>
	</div>
}
<div [@collapse]="collapsedSignal()" [class.ml-24]="to.bulkSelectOptions.enabled">
	@for (option of to.options | formlySelectOptions: field | async; let i = $index; track i) {
		<div
			class="form-check custom-checkbox"
			[ngClass]="{
				'form-check-inline': to.formCheck === 'inline' || to.formCheck === 'inline-switch',
				'form-switch': to.formCheck === 'switch' || to.formCheck === 'inline-switch'
			}">
			<input
				#inputCheckbox
				type="checkbox"
				[id]="id + '_' + i"
				class="form-check-input"
				[value]="option.value"
				[checked]="isChecked(option)"
				[formlyAttributes]="field"
				(change)="onChange(option.value, inputCheckbox.checked)"
				[attr.disabled]="option.disabled || formControl.disabled ? true : null" />
			<label class="form-check-label" [for]="id + '_' + i" [ngClass]="{ disabled: option.disabled }">
				{{ option.label }}
			</label>
		</div>
	}
</div>
